var _defs, _defs2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaves(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "wave",
    style: {
      transform: "rotate(0deg)",
      transition: "0.3s"
    },
    viewBox: "0 0 1440 310",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sw-gradient-0",
    x1: 0,
    x2: 0,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(255, 255, 255, 0.3)",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(255, 255, 255, 0.3)",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      transform: "translate(0, 0px)",
      opacity: 1
    },
    fill: "url(#sw-gradient-0)",
    d: "M0,248L21.8,227.3C43.6,207,87,165,131,165.3C174.5,165,218,207,262,217C305.5,227,349,207,393,170.5C436.4,134,480,83,524,82.7C567.3,83,611,134,655,139.5C698.2,145,742,103,785,118.8C829.1,134,873,207,916,217C960,227,1004,176,1047,160.2C1090.9,145,1135,165,1178,170.5C1221.8,176,1265,165,1309,165.3C1352.7,165,1396,176,1440,149.8C1483.6,124,1527,62,1571,41.3C1614.5,21,1658,41,1702,62C1745.5,83,1789,103,1833,139.5C1876.4,176,1920,227,1964,242.8C2007.3,258,2051,238,2095,211.8C2138.2,186,2182,155,2225,139.5C2269.1,124,2313,124,2356,149.8C2400,176,2444,227,2487,206.7C2530.9,186,2575,93,2618,46.5C2661.8,0,2705,0,2749,46.5C2792.7,93,2836,186,2880,227.3C2923.6,269,2967,258,3011,242.8C3054.5,227,3098,207,3120,196.3L3141.8,186L3141.8,310L3120,310C3098.2,310,3055,310,3011,310C2967.3,310,2924,310,2880,310C2836.4,310,2793,310,2749,310C2705.5,310,2662,310,2618,310C2574.5,310,2531,310,2487,310C2443.6,310,2400,310,2356,310C2312.7,310,2269,310,2225,310C2181.8,310,2138,310,2095,310C2050.9,310,2007,310,1964,310C1920,310,1876,310,1833,310C1789.1,310,1745,310,1702,310C1658.2,310,1615,310,1571,310C1527.3,310,1484,310,1440,310C1396.4,310,1353,310,1309,310C1265.5,310,1222,310,1178,310C1134.5,310,1091,310,1047,310C1003.6,310,960,310,916,310C872.7,310,829,310,785,310C741.8,310,698,310,655,310C610.9,310,567,310,524,310C480,310,436,310,393,310C349.1,310,305,310,262,310C218.2,310,175,310,131,310C87.3,310,44,310,22,310L0,310Z"
  }), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sw-gradient-1",
    x1: 0,
    x2: 0,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(255, 255, 255, 0.3)",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(255, 255, 255, 0.3)",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      transform: "translate(0, 50px)",
      opacity: 0.9
    },
    fill: "url(#sw-gradient-1)",
    d: "M0,217L21.8,206.7C43.6,196,87,176,131,170.5C174.5,165,218,176,262,155C305.5,134,349,83,393,93C436.4,103,480,176,524,191.2C567.3,207,611,165,655,165.3C698.2,165,742,207,785,191.2C829.1,176,873,103,916,67.2C960,31,1004,31,1047,46.5C1090.9,62,1135,93,1178,129.2C1221.8,165,1265,207,1309,232.5C1352.7,258,1396,269,1440,273.8C1483.6,279,1527,279,1571,258.3C1614.5,238,1658,196,1702,175.7C1745.5,155,1789,155,1833,160.2C1876.4,165,1920,176,1964,170.5C2007.3,165,2051,145,2095,144.7C2138.2,145,2182,165,2225,155C2269.1,145,2313,103,2356,93C2400,83,2444,103,2487,108.5C2530.9,114,2575,103,2618,108.5C2661.8,114,2705,134,2749,149.8C2792.7,165,2836,176,2880,175.7C2923.6,176,2967,165,3011,144.7C3054.5,124,3098,93,3120,77.5L3141.8,62L3141.8,310L3120,310C3098.2,310,3055,310,3011,310C2967.3,310,2924,310,2880,310C2836.4,310,2793,310,2749,310C2705.5,310,2662,310,2618,310C2574.5,310,2531,310,2487,310C2443.6,310,2400,310,2356,310C2312.7,310,2269,310,2225,310C2181.8,310,2138,310,2095,310C2050.9,310,2007,310,1964,310C1920,310,1876,310,1833,310C1789.1,310,1745,310,1702,310C1658.2,310,1615,310,1571,310C1527.3,310,1484,310,1440,310C1396.4,310,1353,310,1309,310C1265.5,310,1222,310,1178,310C1134.5,310,1091,310,1047,310C1003.6,310,960,310,916,310C872.7,310,829,310,785,310C741.8,310,698,310,655,310C610.9,310,567,310,524,310C480,310,436,310,393,310C349.1,310,305,310,262,310C218.2,310,175,310,131,310C87.3,310,44,310,22,310L0,310Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaves);
export default __webpack_public_path__ + "static/media/waves.34e7d3b4a47cf1e98c27d2cdc109fac3.svg";
export { ForwardRef as ReactComponent };